import { ReactElement } from "react"
import { pushClickSessionCta } from "../../../../utils/gtm"
import { Wrapper } from "../wrapper/wrapper"
import { AboutProps } from "./about-props"
import * as S from './about-styles'

const cards: Record<string, any> = {
  health: { image: '/uploads/saude.svg', title: 'Saúde', description: 'Consulta médica presencial e teleconsulta - atendimento online' },
  drugs: { image: '/uploads/medicamentos.svg', title: 'Medicamentos', description: 'Medicamentos com até 35% de desconto nas redes Droga Raia e Drogasil' },
  exams: { image: '/uploads/exames.svg', title: 'Exames', description: 'Exames com até 70% de desconto' },
  discounts: { image: '/uploads/descontos.svg', title: 'Descontos', description: 'Descontos em milhares de lojas e estabelecimentos pelo app' },
  cashback: { image: '/uploads/cashback.svg', title: 'Dinheiro de volta', description: 'Cashback em milhares de lojas e estabelecimentos pelo app' },
  clinics: { image: '/uploads/clinica.svg', title: 'Clínicas', description: 'Mais de 450 clínicas parceiras de atendimento médico e odontológico' }
}

export function About ({ id, values, name, apiUrl, mainLink, params, urlBuilder }: AboutProps): ReactElement {
  return <S.Container id={id}>
    <Wrapper>
      <S.Title>{values.title}</S.Title>
      <S.Description dangerouslySetInnerHTML={{ __html: values.description }} />

      <S.Content>
        <img src={values.image} alt={name} />
        <S.CardsWrapper>
          {values.items.map(item => <S.Card>
            <img src={`${apiUrl}${cards[item].image}`} alt="" />
            <div>
              <h5>{cards[item].title}</h5>
              <p>{cards[item].description}</p>
            </div>
          </S.Card>)}
          <S.Link href={urlBuilder.build(mainLink, params)} onClick={() => pushClickSessionCta(name)}>{values.buttonTitle}</S.Link>
        </S.CardsWrapper>
      </S.Content>
    </Wrapper>
  </S.Container>
}